import classnames from "classnames";
import React from "react";
import { WrappedFieldProps } from "redux-form";

import { removeSpaces } from "seneca-common/utils/functions";

import Checkbox from "features/common/components/Checkbox";

import "./FormCheckboxGroup.scss";

type Props = WrappedFieldProps & {
  options: Array<string>;
  checkboxLabelClassName?: string;
  pulse: boolean;
  hideError?: boolean;
};

export default class FormCheckboxGroup extends React.PureComponent<Props> {
  _changeHandlers = {};

  buildOptionChangeHandler = (value: string) => () => {
    this.props.input.onChange(value);
  };

  render() {
    const {
      options,
      pulse,
      checkboxLabelClassName,
      hideError = false,
      ...fieldProps
    } = this.props;
    const { input, meta } = fieldProps;
    const { value } = input;
    const { error, submitFailed } = meta;

    const optionsError = error && submitFailed;

    return (
      <div className="FormCheckboxGroup">
        {options.map((option, index) => {
          const cachedOptionName = removeSpaces(option);

          // cache change handlers so we don't create new functions each render
          if (!(this._changeHandlers as any)[cachedOptionName]) {
            (this._changeHandlers as any)[cachedOptionName] =
              this.buildOptionChangeHandler(option);
          }

          return (
            <div
              className={classnames("FormCheckboxGroup__option", {
                "FormCheckbox--error": optionsError,
                "FormCheckbox--pulseError": optionsError && pulse
              })}
              key={index}
            >
              <Checkbox
                selected={value === option}
                text={option}
                checkboxClassName={classnames(
                  "FormCheckbox__checkBox",
                  checkboxLabelClassName
                )}
                onChange={(this._changeHandlers as any)[cachedOptionName]}
              />
            </div>
          );
        })}
        {optionsError && !hideError && (
          <div className="FormCheckboxGroup__error">{error}</div>
        )}
      </div>
    );
  }
}
